export default {
    "generateCustomerToken": "90143320626ad98967574fdd8501ec0119f6f7345b8adceb2a83194901ff1246",
    "revokeCustomerToken": "fc13aa4ee0a1e035e3d3c9471bda78ef85534871549b6810ca527230dc31e7dd",
    "createCustomer": "a46799a5444ec5d72fc13554eb4ca2003d1fb631d0a846084b144fec52224508",
    "requestPasswordResetEmail": "55538fa1f73961abf4d0be6a6983f8807294090f3ee540db06532cf707179626",
    "resetPassword": "00bf8d4989b5c5925e0ab663339ce9bf21d7b7d2d879493749192926d3057ca0",
    "changeCustomerPassword": "4c54126f9fae8ab752ecfc7346967c098ea2bbbe338265de60b3ced1b2104c65",
    "updateCustomerEmail": "fc43b38b78f699e2199a95c09c28ee0f3b69ea707cf2ef953f49b2809c6219e1",
    "updateCustomer": "9979f16b1474349bbefc6a12f207b492fc44d3b8aed5be2af0dbead65429f464",
    "requestPasswordOtp": "1b0a58a4bb4f615c7ac387a28ca017b0e5e94c89541196dbf09d2432f0aebaec",
    "verifyPasswordOtp": "273adccccedce6fd4f97959446394ac33f9eda4606e96363b9f6554b9d1b9034"
};
